import { type FC, useState } from "react";
import LoginIcon from "@mui/icons-material/Login";
import { Button } from "@mui/material";

import { startSignIn } from "../../../authentication/shared/start-sign-in";

interface SignInButtonProps {
  label?: string;
  returnUrl?: string | null;
}

export const SignInButton: FC<SignInButtonProps> = ({
  label = "Войти снова",
  returnUrl,
}) => {
  const [isRedirecting, setRedirecting] = useState(false);

  const handleClick = () => {
    setRedirecting(true);
    startSignIn(returnUrl);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<LoginIcon />}
      disabled={isRedirecting}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};
